import React from 'react';

import { ReactProps } from '../../../typings/common-types';

import Icon, { IIcon } from './icon';

const svg = (props: ReactProps) => (
  <svg viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg" fill="currentColor" {...props}>
    <path
      d="M54.348 50.781l10.738 10.59L80 76.078l-4.903 3.435a3 3 0 01-3.842-.336L48.58 56.502a30.178 30.178 0 01-18.268 6.121C13.57 62.623 0 49.053 0 32.312S13.571 2 30.312 2c16.74 0 30.311 13.571 30.311 30.312a30.18 30.18 0 01-6.275 18.47zm-24.036 3.76c12.276 0 22.228-9.953 22.228-22.23 0-12.276-9.952-22.228-22.228-22.228-12.277 0-22.229 9.952-22.229 22.229 0 12.276 9.952 22.228 22.229 22.228z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

const IconSearch: React.FC<IIcon> = (props: ReactProps) => <Icon {...props} svg={svg} />;

export default IconSearch;
